import React from 'react';
import { ArchiveIcon, EyeOffIcon } from './icons';

/**
 * ToolbarArchiveToggle
 * 
 * Shared component for the archive toggle button that appears in
 * Kanban, Table, Gantt, and Todo toolbars.
 */
const ToolbarArchiveToggle = ({
  showArchived = false,
  onToggleArchived,
  archivedCount = 0,
}) => {
  return (
    <button
      className={`toolbar-btn ${showArchived ? 'toolbar-btn--active' : ''}`}
      onClick={onToggleArchived}
      title={showArchived ? 'Hide archived tasks' : 'Show archived tasks'}
    >
      <span className="toolbar-btn__content">
        <span className="toolbar-btn__icon">
          {showArchived ? <EyeOffIcon /> : <ArchiveIcon />}
        </span>
        <span className="toolbar-btn__label">
          {showArchived ? 'Hide Archived' : archivedCount > 0 ? `Archived (${archivedCount})` : 'Archived'}
        </span>
      </span>
    </button>
  );
};

export default ToolbarArchiveToggle;
